import { BorshAccountsCoder } from "@coral-xyz/anchor";
import { useAccount } from "@helium/account-fetch-cache-hooks";
import { useMemo } from "react";
import { capitalizeFirstChar } from "./useIdlAccounts";
export function useIdlAccount(key, idl, type, 
// Perf optimization - set if the account will never change, to lower websocket usage.
isStatic = false) {
    const parser = useMemo(() => {
        if (idl) {
            const coder = new BorshAccountsCoder(idl);
            const tpe = capitalizeFirstChar(type);
            return (pubkey, data) => {
                try {
                    if (data.data.length === 0)
                        return;
                    const decoded = coder.decode(tpe, data.data);
                    decoded.pubkey = pubkey;
                    return decoded;
                }
                catch (e) {
                    console.error(e);
                }
            };
        }
    }, [idl, type]);
    return useAccount(key, parser, isStatic);
}
//# sourceMappingURL=useIdlAccount.js.map